import axios from 'axios';
import properties from '../../core-utils/properties';

export interface ClaimsTrendData {
  month: number;
  year: number;
  totalBilledAmount: number;
  totalRejectedClaims: number;
  rejectedClaimsPercent: number;
}

export const claimTrendAPICall = async (
  params: any,
  setClaimsTrendData: any,
  setIsDataEmpty?: any,
  setIsDataEmptyWithHurrayMessage?: any,
  signal?: any,
) => {
  //API CALL
  const baseUrl = properties.aiqBaseUrl + properties.getRejectedClaimsPercent;

  await axios
    .post(baseUrl, params, { signal })
    .then((res) => {
      if (res) {
        setClaimsTrendData(res.data?.data);
        if (res.data?.data !== undefined && res.data?.data.length !== 0) {
          setIsDataEmpty(false);
          setIsDataEmptyWithHurrayMessage(false);
        } else {
          setIsDataEmpty(true);
          setIsDataEmptyWithHurrayMessage(true);
        }
      }
    })
    .catch(() => {});
};

export const getMonthYear = (month: number, year: number) => {
  const monthArray: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return monthArray[month - 1] + ' ' + year;
};
